import React, { useEffect } from 'react'; 
import Header from '../../Header';
import Footer from '../../Footer';
import useRouteMeta from '../../../../hooks/useRouteMeta';
import '../../Blogs/Blogs.css'; // Reusing blogs.css for details page for now exactly as blog

const CaseStudy1 = () => {
  useRouteMeta();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="blog-detail-page">
      <Header />

      {/* Hero Title */}
      <div className="blog-detail-hero">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-11 col-lg-11">
              <h1 className="blog-detail-title text-center">
                70% Cost Reduction in Product Photography
              </h1>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Content */}
      <div className="blog-detail-body">
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-md-11 col-lg-11">

              {/* Section 1 */}
              <div className="blog-section">
                <h2 className="blog-section-heading">
                  From 20 Designs to 500: A Jewellery Brand's Scaling Story
                </h2>
                <p className="blog-para">
                  When Meera, the founder of a growing jewellery brand, launched her latest collection, she faced a familiar challenge.                </p>
                <p className="blog-para">
                  Her designs were ready—beautiful, unique, and market-ready. But her jewellery photoshoot budget? Completely stretched.
                </p>
                <p className="blog-para">
                  Each new product you add means hours of arranging, coordinating, retouching, and waiting. The cost stacks up. And if a product doesn't sell well, you've already spent thousands on making it pretty.
                </p>
                <p className="blog-para">
                  Each new product required a separate shoot. Every variation meant additional cost. And scaling her catalog felt like an expensive, slow process.

                </p>
                <p className="blog-para">
                  She asked herself:< br />"Do I need to spend more every time I want to grow?"

                </p>
              </div>

              {/* Section 2 */}
              <div className="blog-section">
                <h2 className="blog-section-heading">
                  The Bottleneck: Traditional Jewellery Photoshoots
                </h2>
                <p className="blog-para">
                  Like many brands, Meera relied heavily on traditional jewellery photoshoots:

                </p>
                <ul className="blog-check-list">
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Studio bookings
                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Photographer fees
                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Editing and retouching
                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Multiple reshoots for variations
                  </li>
                </ul>
                <p className="blog-para">
                  What started as a necessity quickly became a limitation.

                </p>
                <p className="blog-para">
                  Even though her business demand was growing, her catalog expansion wasn’t keeping up.

                </p>
              </div>

              {/* Section 3 */}
              <div className="blog-section">
                <h2 className="blog-section-heading">
                  The Turning Point: Smarter Jewellery Photo Strategy

                </h2>
                <p className="blog-para">
                  That’s when Meera discovered a better approach—leveraging AI to scale her jewellery photos.
                  Instead of organizing a shoot for every SKU, she:
                </p>
                <ul className="blog-check-list">
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Used one high-quality base image

                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Shoot real jewellery variations digitally
                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Created multiple variations digitally
                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    Experimented with backgrounds and styles                  </li>
                  <li>
                    <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" />
                    <span>Discover how this works: </span> <span><a href="https://glammify.ai/" target="_blank" rel="noreferrer" className="blog-link">https://glammify.ai/</a></span>
                  </li>
                </ul>

                <p className="blog-para">
                  Suddenly, what once took weeks could be done in hours.

                </p>
              </div>

              {/* Section 4 */}
              <div className="blog-section">
                <h2 className="blog-section-heading">
                  Scaling Without Scaling Costs
                </h2>
                <p className="blog-para">
                  With this shift, Meera transformed her workflow:                </p>

                <div className="blog-highlight-block">
                  <h3 className="blog-highlight-title">  <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" /> One Shoot, Multiple Outputs</h3>
                  <p className="blog-para">
                    A single jewellery photoshoot now produced:
                  </p>
                  <ul className="blog-check-list checklist2">
                    <li>
                      Website images
                    </li>
                    <li>
                      Social media creatives
                    </li>
                    <li> Marketplace-ready visuals </li>
                  </ul>
                </div>

                <div className="blog-highlight-block">
                  <h3 className="blog-highlight-title">  <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" /> Digital Variations
                  </h3>
                  <p className="blog-para">
                    Instead of manufacturing every variation:

                  </p>
                  <ul className="blog-check-list checklist2">
                    <li>
                      Gold became rose gold digitally
                    </li>
                    <li>
                      Gemstones were swapped virtually
                    </li>
                    <li>Designs evolved without reshooting
                    </li>
                  </ul>
                </div>

                <div className="blog-highlight-block">
                  <h3 className="blog-highlight-title">  <img src="/assets/img/website/check-icon.svg" alt="check" className="blog-check-icon" /> Faster Product Launches

                  </h3>
                  <p className="blog-para">
                    Her brand could now:
                  </p>
                  <ul className="blog-check-list checklist2">
                    <li>
                      Launch collections quickly                    </li>
                    <li>
                      Test new designs
                    </li>
                    <li>Stay ahead of trends

                    </li>
                  </ul>
                  <p className="blog-para">
                    Explore pricing options: <a href="https://glammify.ai/pricing" target="_blank" rel="noreferrer" className="blog-link">https://glammify.ai/pricing</a>
                  </p>
                </div>

              </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </div>
  );
};

export default CaseStudy1;
